var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.71,15.29l-1-1-.71-.29h-4l-.71,.29-3.49,3.49-1.21-.61-3.77-3.77-.61-1.21,3.49-3.49,.29-.71V4l-.29-.71-1-1-.71-.29h-2.98l-.7,.29-1.02,1-.3,.71v6l.11,.45,2,4,.19,.26,4,4,.26,.19,4,2,.45,.11h6l.71-.29,1-1,.29-.71v-3l-.29-.71ZM5.27,10.31l-.27-.55V4.42l.43-.42h2.16l.41,.41v3.17l-2.73,2.73Zm14.73,8.27l-.41,.41h-5.35l-.55-.27,2.73-2.73h3.17l.41,.41v2.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/1775731007/media/icon-phone.86ca1b0fffe57093f26f7684b25b4228.svg";
export { ForwardRef as ReactComponent };